import { get } from 'lodash';

const stack = get(new Error(), 'stack', '').toString();
const isDev = process.env.NODE_ENV !== 'production';

export const isVerboseDebugAllowed =
  isDev || stack.includes('<isolated-vm>') || stack.includes('sled.wix.dev');
